import { FC, memo } from "react";

const CheckOutline: FC = () => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="9.50004"
          cy="9.4987"
          r="7.16667"
          stroke="#167E76"
          strokeWidth="1.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9582 7.2305C13.0977 7.3707 13.0972 7.59746 12.957 7.73698L8.27882 12.3927C8.1391 12.5318 7.91328 12.5318 7.77356 12.3927L5.64713 10.2765C5.50693 10.137 5.50639 9.9102 5.64591 9.77C5.78544 9.62981 6.0122 9.62926 6.15239 9.76879L8.02619 11.6336L12.4517 7.22929C12.5919 7.08976 12.8186 7.09031 12.9582 7.2305Z"
          fill="#167E76"
          stroke="#167E76"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default memo(CheckOutline);
